import styled, { css } from 'styled-components'

import { bordergray, white, mediumgray } from '../../styles/colors'
import { minmedia, maxmedia } from '../../styles/media-queries'

export const InputOverlay = styled.div`
  display: none;
  ${maxmedia.medium`
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  `};
`

export const Price = styled.div`
  margin-top: 0.5rem;
  text-transform: lowercase;
  font-style: italic;
  font-size: 12px;
  font-weight: 300;
  width: 100%;
  ${minmedia.medium`
    font-size: 14px;
  `} ${minmedia.large`
    font-size: 14px;
  `};
`

export const Product = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding-left: 0.5rem;
  background-color: ${white};
  border-bottom: 1px solid ${bordergray};

  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  ${props =>
    props.small &&
    css`
      ${OrderCount} {
        height: 76px;
      }
      ${ImageContainer}::before {
        padding-top: 75%;
      }
    `};

  ${minmedia.medium`
    padding-left: 1rem;
  `};
  ${minmedia.large`
    border: 1px solid ${bordergray};
    padding-left: 2rem;
    border-top: 0;
  `};
`

export const Meta = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;

  ${minmedia.medium`
    width: calc(100% - 300px);
  `} ${minmedia.large`
    width: calc(100% - 350px);
  `};
`

export const Inputs = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;

  ${minmedia.medium`
    width: 300px;
    justify-content: flex-end;
  `} ${minmedia.large`
    width: 350px;
  `};
`

export const ImageContainer = styled.div`
  width: 75px;
  position: relative;
  cursor: pointer;

  ${minmedia.medium`
    width: 100px;
  `} &::before {
    content: '';
    display: block;
    padding-top: 100%;
  }
  img {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    object-fit: contain;
    object-position: center center;
  }
`

export const Image = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  object-fit: contain;
  object-position: center center;
`

export const TitleContainer = styled.div`
  padding: 0.5rem 0.75rem 0.5rem 0.5rem;
  width: calc(100% - 75px); //minus image
  ${minmedia.medium`
    width: calc(100% - 100px); //minus image
    padding: 0 1rem;
  `} ${minmedia.large`
    padding: 0 2rem;
  `};
`

export const Description = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: 300;
  width: 100%;
  font-style: italic;
  color: ${mediumgray};
  ${minmedia.medium`
    font-size: 16px;
  `} ${minmedia.large`
    font-size: 16px;
  `};
`

export const Title = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 300;
  width: 100%;
  ${minmedia.medium`
    font-size: 18px;
  `} ${minmedia.large`
    font-size: 18px;
  `};
`

export const InputContainer = styled.div`
  ${minmedia.medium`
    padding-right: 1.5rem;
  `} ${minmedia.large`
    padding-right: 3rem;
  `};
`

export const OrderCount = styled.div`
  width: 100px;
  text-align: center;
  ${maxmedia.medium`
    font-size: 14px;
  `};
  ${minmedia.medium`
    border-left: 1px solid ${bordergray};
    height: 110px;
  `};
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`



// WEBPACK FOOTER //
// ./src/components/Order/styles.js